module.exports = __webpack_public_path__ + "assets/img/step2-1-sz.3df4b399.png";